<template>
  <div class="add-news-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body" style="min-height: 600px;">
          <div class="card-title">
            资讯管理
            <el-button type="primary" size="small" style="float: right" icon="el-icon-edit" @click="publish">立即发布</el-button>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="6">
                <div class="upload-images">
                  <div :class="active===0?'upload-image-first active':'upload-image-first'" @click="getContent(0)">
                    <div class="upload-back" :style="news[0].image.imgid!==''?'background:none;':''">
                      <i class="el-icon-picture-outline" style="font-size: 50px;" v-if="news[0].image.imgid===''"/>
                      <div class="title" v-if="news[0].title===''">标题</div>
                      <img :src="news[0].image.imgurl" v-if="news[0].image.imgid!==''" style="max-height:100%;max-width: 100%;"/>
                      <div class="title" v-if="news[0].title!==''">{{news[0].title}}</div>
                    </div>
                  </div>
                  <div class="news-list">
                    <div :class="active===index?'news-box active':'news-box'" v-for="(item,index) in news" v-if="news.length>1 && index>0" @click="getContent(index)">
                      <div class="news-img-sm">
                        <img :src="item.image.imgurl">
                      </div>
                      <div class="news-title-sm" v-if="item.title!==''">{{item.title}}</div>
                      <div class="news-title-sm" v-if="item.title===''">标题</div>
                    </div>
                  </div>
                  <div class="add-news-box" @click="addNewsBox">
                    <i class="el-icon-plus"/>
                    添加资讯
                  </div>
                </div>
              </el-col>
              <el-col :span="18" style="padding-left: 30px;padding-top:10px;">
                <div class="demo-input-suffix">
                  &emsp;&emsp;<span><span style="color: crimson">*</span>标题：</span>
                  <el-input
                    placeholder="请输入内容"
                    show-word-limit
                    maxlength="100"
                    style="width: 90%;"
                    v-model="news[active].title">
                  </el-input>
                </div>
                <div class="demo-input-suffix" style="display: inline-flex;margin-top: 10px;">
                  <span><span style="color: crimson">*</span>封面图片：&nbsp;</span>
                  <SingleImg :key="active" v-model="news[active].image" :oldurl="news[active].image.imgurl"/>
                </div>
                <div class="demo-input-suffix">
                  &emsp;&emsp;<span><span style="color: crimson">*</span>内容：</span>
                  <tinymce ref="tinymce" v-model="news[active].content" :height="200" style="margin-top: 10px;width:90%;display: inline-flex;" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getUser } from '@/utils/auth'
  import SingleImg from '@/components/upload/SingleImg'
  import tinymce from '@/components/Tinymce'
  import { addNews } from '@/api/work'
  import qs from 'qs'

  export default {
    name: 'add_news',
    inject:['reload'],
    computed: {
      user: getUser
    },
    components:{
      SingleImg,tinymce
    },
    data(){
      return{
        news: [
          {
            title: '',
            content: '',
            image: {
              imgid: '',
              imgurl: ''
            }
          }
        ],
        total: 1,
        active: 0,
        richKey: '',
      }
    },
    methods:{
      addNewsBox(){
        const data = {
          title: '',
          content: '',
          image: {
            id: '',
            url: ''
          }
        }
        this.news.push(data)
      },
      getContent(active){
        this.active = active
        this.$refs['tinymce'].setContent(this.news[active].content)
      },
      publish(){
        for(let i = 0; i<this.news.length; i++){
          let news = this.news[i]
          if(news.title===''){
            this.$message({
              type: 'warning',
              message: '您还没有填写第'+(i+1)+'项资讯的标题'
            });
            return false
          }
          if(news.image.imgid===''){
            this.$message({
              type: 'warning',
              message: '您还没有上传第'+(i+1)+'项资讯的封面图'
            });
            return false
          }
          if(news.content===''){
            this.$message({
              type: 'warning',
              message: '您还没有填写第'+(i+1)+'项资讯的内容'
            });
            return false
          }
        }
        let jsonStr = []
        for(let i = 0; i<this.news.length; i++){
          const json = {
            title: '',
            content: '',
            imgId: ''
          }
          json.title = this.news[i].title
          json.content = this.news[i].content
          json.imgId = this.news[i].image.imgid
          jsonStr.push(json)
        }

        let s = qs.parse(jsonStr)
        addNews({dataStr: s,userid:this.user.dUserid}).then(response=>{
          this.$message({
            type: 'success',
            message: '添加成功'
          });
          this.reload()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          font-weight: 500;
          color: #404852;
          margin-bottom: 22px;
          font-size: 14px;
        }
        .card-content{
          .upload-images{
            width: 100%;
            padding: 10px;
            .upload-image-first{
              cursor: pointer;
              padding:10px;
              .upload-back{
                width: 100%;
                height: 160px;
                text-align: center;
                overflow: hidden;
                line-height: 160px;
                position: relative;
                background-color: #ebebeb;
                .title{
                  position: absolute;
                  background: rgba(0,0,0,.6);
                  line-height: 40px;
                  width: 100%;
                  bottom: 0;
                  left: 0;
                  text-align: left;
                  padding: 0 10px;
                  color: #fff;
                  box-sizing: border-box;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .news-list{
              .news-box{
                padding: 10px;
                box-sizing: border-box;
                position: relative;
                border: 1px solid #e2e2e2;
                cursor: pointer;
                .news-img-sm{
                  background: #ebebeb;
                  width: 50px;
                  height: 50px;
                  position: absolute;
                  right: 10px;
                  top: 10px;
                  text-align: center;
                  img{
                    height:50px;
                    width: 50px;
                  }
                }
                .news-title-sm{
                  width: 100%;
                  padding-right: 60px;
                  height: 50px;
                  box-sizing: border-box;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
            }
            .add-news-box{
              line-height: 60px;
              width: 100%;
              text-align: center;
              cursor: pointer;
              border: 1px dashed #e2e2e2;
              border-top: 0;
              box-sizing: border-box;
            }
            .active{
              border: 2px solid #409EFF!important;
            }
          }
        }
      }
    }
  }
</style>
